import { h } from "preact";
import { css } from "emotion";
import config from "../config"
const squareLogo = require("../assets/images/logos/square.svg");

const eventCharity = css({
  padding: "17px 15px",
  textAlign: "center",
  border: "1px solid #DEDEDE",
  borderRadius: 4,
  color: "#323232",
  textDecoration: "none",
  display: "block",
  ":hover,:focus": {
    textDecoration: "underline",
    color: "#323232"
  }
});

const description = css({
  color: "#323232",
  fontSize: 14,
  letterSpacing: "-0.33px",
  textAlign: "center",
  marginTop: 10,
  marginBottom: 0,  
})

const imageWrapper = css({
  height: 80,
  maxWidth: 80,
  margin: "0px auto",
  padding: "0px 0px 0px 0px",
});


const HumanitixCause = ({ eventOrganiser }) => {
  const descText = (eventOrganiser && eventOrganiser.name) 
  ? `Humanitix is 100% about closing the education gap and supporting the world changing work of organisations like ${eventOrganiser.name}.` 
  : "Humanitix is 100% about closing the education gap around the world.";

  return (
    <a href={`${config("WEBSITE_URL")}/our-impact`} className={eventCharity}>
      <img src={squareLogo} alt="Humanitix Logo" className={imageWrapper}/>
      <p className={description}>{descText}</p>
    </a>
  );
};
export default HumanitixCause;
